import React from "react";
import PropTypes from "prop-types";
import { Badge, Flex, Icon, Popover, StyledLink } from "orcs-design-system";

/** Icon + text row item matching ProfileHeader stats styling. */
const HeaderMetaItem = ({
  icon,
  label,
  popoverContent,
  popoverTextAlign,
  title,
  to,
  "data-testid": dataTestId,
}) => {
  const tooltip = popoverContent ?? title;
  // StyledLink default fontSizes.2 inflates Badge; match Badge type scale.
  const content = to ? (
    <StyledLink
      to={to}
      fontSize={0}
      lineHeight={0}
      style={{ color: "inherit" }}
    >
      {label}
    </StyledLink>
  ) : (
    label
  );

  const badge = (
    <Badge data-testid={dataTestId}>
      {icon ? (
        <Flex alignItems="center" gap="s">
          <Icon icon={icon} />
          {content}
        </Flex>
      ) : (
        content
      )}
    </Badge>
  );

  if (!tooltip) {
    return badge;
  }

  return (
    <Popover
      direction="top"
      width="fit-content"
      text={tooltip}
      textAlign={popoverTextAlign}
    >
      {badge}
    </Popover>
  );
};

HeaderMetaItem.propTypes = {
  icon: PropTypes.array,
  label: PropTypes.node.isRequired,
  popoverContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  popoverTextAlign: PropTypes.oneOf(["left", "right", "center"]),
  title: PropTypes.string,
  to: PropTypes.string,
  "data-testid": PropTypes.string,
};

export default HeaderMetaItem;
